module.exports = __webpack_public_path__ + "static/JL.190207.COH.WEBW.Gallery2-446deab8b6ff2e0b154f12137fc42fac.jpg";